'use strict'

var proto = { // eslint-disable-line
  name: '',
  value: ''
}

export const COLOR = {}
export const GRADIENT = {}
